module.exports = __webpack_public_path__ + "static/tribal-leadership-9d34a8c899acfc97ad890f6482d0ace9.jpg";